<template>
  <Modal ref="baseModal">
    <div
      class="modal-popup active"
      tabindex="0"
      @keydown.enter.stop.prevent="confirm"
      @keydown.esc.stop.prevent="confirm"
    >
      <div class="modal-wrap">
        <div
          class="icon-box"
          :class="{
          'info-icon': iconClass == 'info',
          'info-icon-r' : iconClass == 'error',
          'check-icon' : iconClass == 'check',
          'back-icon' : iconClass == 'back'
        }"
        ></div>
        <p class="modal-title">{{title}}</p>
        <p class="modal-text" v-html="content"></p>
        <button
          ref="confirmButton"
          type="button"
          class="modal-btn"
          @click="confirm"
        >{{confirmButtonText}}</button>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from "@/components/common/Modal.vue";

// 서버 에러 응답(JSON)에서 표시 메시지를 만든다.
// - @Valid 검증 실패: errors[].reason(필드별 사유)을 우선 노출
// - 그 외: message
// - null/문자열/Blob 등 예외 입력은 안전하게 폴백
function buildErrorMessage(data) {
  const FALLBACK = "서버와 통신 중 오류가 발생하였습니다.";
  if (!data || (typeof Blob !== "undefined" && data instanceof Blob))
    return FALLBACK;
  if (typeof data === "string") return data || FALLBACK;

  if (Array.isArray(data.errors) && data.errors.length) {
    const details = data.errors
      .map((e) => e && e.reason)
      .filter(Boolean)
      .join("<br>");
    if (details) return details;
  }

  if (data.message) return data.message;

  return FALLBACK;
}

export default {
  components: {
    Modal,
  },
  data: () => ({
    title: "확인",
    content: "확인해 주세요.",
    confirmButtonText: "확인",
    resolvePromise: undefined,
    iconClass: "info",
  }),
  methods: {
    show(content) {
      this.setContent(content);
      this.$refs.baseModal.open();

      return new Promise((resolve) => {
        this.resolvePromise = resolve;
        this.openModal();
      });
    },

    showError(error) {
      this.iconClass = "error";

      console.error(error);

      // blob 에러는 commonInterceptor에서 JSON으로 정규화됨 → 여기선 분기 불필요
      const data = error && error.response ? error.response.data : null;
      this.setContent({
        title: "알림",
        content: buildErrorMessage(data),
      });

      return new Promise((resolve) => {
        this.resolvePromise = resolve;
        this.openModal();
      });
    },
    info(content) {
      this.iconClass = "info";
      return this.show(content);
    },

    check(content) {
      this.iconClass = "check";
      return this.show(content);
    },

    back(content) {
      this.iconClass = "back";
      return this.show(content);
    },

    error(content) {
      this.iconClass = "error";
      return this.show(content);
    },

    openModal() {
      this.$refs.baseModal.open();

      this.$nextTick(() => {
        this.$refs.confirmButton?.focus();
      });
    },

    confirm() {
      this.$refs.baseModal.close();

      const resolve = this.resolvePromise;
      this.resolvePromise = undefined;
      resolve?.(true);
    },

    setContent(content) {
      this.title = content.title ? content.title : this.title;
      this.content = content.content ? content.content : this.content;
      this.confirmButtonText = content.confirmButtonText
        ? content.confirmButtonText
        : this.confirmButtonText;
    },
  },
};
</script>